import { RecommendationsProductSocial } from './src/recommendations-product-social';

export default RecommendationsProductSocial;
